import { Drawer } from '@aspendental/shared-components-web';
import { Box } from '@mui/material';
import { FC } from 'react';
import LoginBody from '../LoginWithEmailModalBody';
import { drawerWrapper } from './LoginWithEmailTipsDrawer.styles';
type LoginWithEmailTipsDrawerProps = {
  toggleTipsDialog: () => void;
  isTipsDialogVisible: boolean;
};
const LoginWithEmailTipsDrawer: FC<LoginWithEmailTipsDrawerProps> = ({
  toggleTipsDialog,
  isTipsDialogVisible
}) => {
  return <Drawer data-test-id="patient-services-tips-drawer" draggable roundedTop anchor="bottom" open={isTipsDialogVisible} onClose={toggleTipsDialog} role="dialog" aria-labelledby="dialog-title" data-sentry-element="Drawer" data-sentry-component="LoginWithEmailTipsDrawer" data-sentry-source-file="LoginWithEmailTipsDrawer.tsx">
			<Box sx={drawerWrapper} data-sentry-element="Box" data-sentry-source-file="LoginWithEmailTipsDrawer.tsx">
				<LoginBody data-sentry-element="LoginBody" data-sentry-source-file="LoginWithEmailTipsDrawer.tsx" />
			</Box>
		</Drawer>;
};
export default LoginWithEmailTipsDrawer;